import { Clock, MapPin } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const LANGUAGE_FLAGS = {
  ES: "🇪🇸",
  EN: "🇬🇧",
  FR: "🇫🇷",
  DE: "🇩🇪",
  IT: "🇮🇹",
  PT: "🇵🇹",
  CAT: "🏴󠁥󠁳󠁣󠁴󠁿",
  EU: "🏴",
  VAL: "🏴",
  AR: "🇸🇦",
  NL: "🇳🇱",
};

const LANGUAGE_NAMES = {
  ES: "Español",
  EN: "Inglés",
  FR: "Francés",
  DE: "Alemán",
  IT: "Italiano",
  PT: "Portugués",
  CAT: "Catalán",
  EU: "Euskera",
  VAL: "Valenciano",
  AR: "Árabe",
  NL: "Holandés",
};

const DAY_COLORS = {
  Lunes: "bg-blue-100 text-blue-700",
  Martes: "bg-green-100 text-green-700",
  Miércoles: "bg-yellow-100 text-yellow-700",
  Jueves: "bg-purple-100 text-purple-700",
  Viernes: "bg-pink-100 text-pink-700",
  Sábado: "bg-orange-100 text-orange-700",
  Domingo: "bg-teal-100 text-teal-700",
};

export const EventsTable = ({ events }) => {
  return (
    <div className="overflow-x-auto rounded-2xl border border-border bg-white" data-testid="events-table">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="font-heading font-semibold text-foreground w-[100px]">
              Día
            </TableHead>
            <TableHead className="font-heading font-semibold text-foreground">
              Evento
            </TableHead>
            <TableHead className="font-heading font-semibold text-foreground hidden sm:table-cell">
              Hora
            </TableHead>
            <TableHead className="font-heading font-semibold text-foreground hidden md:table-cell">
              Lugar
            </TableHead>
            <TableHead className="font-heading font-semibold text-foreground">
              Idiomas
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {events.map((event, index) => (
            <TableRow 
              key={index} 
              className="table-row-hover"
              data-testid={`event-row-${index}`}
            >
              <TableCell>
                <Badge 
                  variant="outline" 
                  className={`${DAY_COLORS[event.day]} border-0 font-medium`}
                >
                  {event.day}
                </Badge>
              </TableCell>
              <TableCell>
                <div>
                  <p className="font-medium text-foreground">{event.name}</p>
                  <div className="sm:hidden flex items-center gap-2 mt-1 text-sm text-muted-foreground">
                    <Clock className="w-3 h-3" />
                    {event.time}
                  </div>
                  <div className="md:hidden flex items-center gap-2 mt-1 text-sm text-muted-foreground">
                    <MapPin className="w-3 h-3" />
                    {event.location}
                  </div>
                </div>
              </TableCell>
              <TableCell className="hidden sm:table-cell">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Clock className="w-4 h-4" />
                  <span>{event.time}</span>
                </div>
              </TableCell>
              <TableCell className="hidden md:table-cell">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <MapPin className="w-4 h-4" />
                  <span>{event.location}</span>
                </div>
              </TableCell>
              <TableCell>
                <div className="flex flex-wrap gap-1">
                  {event.languages.map((lang) => (
                    <span
                      key={lang}
                      className="language-badge"
                      title={LANGUAGE_NAMES[lang] || lang}
                    >
                      {LANGUAGE_FLAGS[lang] || "🌐"} {lang}
                    </span>
                  ))}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
